<div class="col-md-12">
    <!--<h2>BunnyCRM Sales</h2>-->
    <p>BunnyCRM Sales takes the manual work out of the pipeline — from the moment a lead arrives to the
        moment a deal closes. Leads are captured automatically, ranked by fit and intent, and moved through
        a clear pipeline so your team always knows what to work on next, without a dedicated sales-ops
        person to run the system for them.
    </p>
    <h3>Key Features</h3>
    <ul>
        <li><strong>Lead Capture:</strong> Leads flow in automatically from your website, forms, and integrations, with no manual entry.</li>
        <li><strong>Lead Scoring &amp; Qualification:</strong> Prospects are ranked by fit and intent, so your team spends time on the conversations that matter.</li>
        <li><strong>Pipeline &amp; Deal Tracking:</strong> A clear view of every deal's stage, owner, and next action.</li>
        <li><strong>Automated Follow-Ups:</strong> Scheduled emails, reminders, and task assignments keep deals moving without someone having to chase them.</li>
        <li><strong>Contact &amp; Account Management:</strong> One record per customer, shared across sales and marketing.</li>
    </ul>
</div>
